export const getDynamicBulletsIndex = (currentIndex, previousIndex, dynamicBulletIndex, total) => {
	// Dynamic bullet logic from swiper
	let newDynamicBulletIndex = dynamicBulletIndex + currentIndex - previousIndex;
	if (newDynamicBulletIndex > 2) {
		newDynamicBulletIndex = 2;
	} else if (newDynamicBulletIndex < 0) {
		newDynamicBulletIndex = 0;
	}

	const firstIndex = Math.max(currentIndex - newDynamicBulletIndex, 0);
	const lastIndex = firstIndex + (Math.min(total, 3) - 1);

	return [firstIndex, lastIndex, newDynamicBulletIndex];
};

export const calculateDynamicBulletsOffset = (bullets, firstIndex, lastIndex) => {
	let firstBullet = firstIndex - 2;
	let lastBullet = lastIndex + 2;

	if (firstBullet < 0) {
		firstBullet = 0;
		lastBullet += 0 - firstBullet;
	}

	if (lastBullet >= bullets.length) {
		lastBullet = bullets.length - 1;
	}

	// SSR first render does not have ref elements to get their position
	if (!(bullets[firstBullet] && bullets[lastBullet])) {
		return [0, 0];
	}

	const width =
		bullets[lastBullet].getBoundingClientRect().right -
		bullets[firstBullet].getBoundingClientRect().left;

	const offset = bullets[firstBullet].offsetLeft * -1;

	return [width, offset];
};
